<template>
	<!-- 修改密碼 -->
	<el-dialog  :close-on-click-modal="false" title="修改密碼" :visible.sync="passModel" top="5vh" @close="hide" :width="isphone?'90%':'50%'">
		<!-- 表單内容 -->
		<el-form :rules="pass_rules" ref="pass_form" :model="pass_arr" label-width="100px">
			<el-form-item label="當前密碼" prop="old_pass">
				<el-input v-model="pass_arr.old_pass" :maxlength="16" :minlength="6" show-password placeholder="登錄密碼" size="small"
				 :class="[isphone?'phone_w':'pc_w']"></el-input>
			</el-form-item>

			<el-form-item label="新密碼" prop="pass1">
				<el-input v-model="pass_arr.pass1" :maxlength="16" :minlength="6" show-password placeholder="新密碼" size="small"
				 :class="[isphone?'phone_w':'pc_w']"></el-input>
			</el-form-item>
			<el-form-item label="確認密碼" prop="pass2">
				<el-input v-model="pass_arr.pass2" :maxlength="16" :minlength="6" show-password placeholder="確認密碼" size="small"
				 :class="[isphone?'phone_w':'pc_w']"></el-input>
			</el-form-item>
		</el-form>


		<div slot="footer" class="dialog-footer">
			<el-button @click="hide">取 消</el-button>
			<el-button type="primary" @click="submitpass">確 定</el-button>
		</div>
	</el-dialog>
</template>

<script>
	export default {
		props: {
			passModel: {
				type: Boolean,
				default: false
			},
			isphone: {
				type: Boolean,
				default: false
			}
		},
		data() {
			return {
				pass_arr: {
					old_pass: '',
					pass1: '',
					pass2: '',
				},
				pass_rules: {
					old_pass: [{
						required: true,
						message: "請輸入當前密碼",
						trigger: 'blur',
					}, ],

					pass1: [{
							min: 6,
							max: 16,
							message: '密碼必須6至16個數字或英文字',
							trigger: 'blur'
						},
						{
							required: true,
							message: "請輸入新密碼",
							trigger: 'blur',
						}
					],
					pass2: [{
							min: 6,
							max: 16,
							message: '密碼必須6至16個數字或英文字',
							trigger: 'blur'
						},
						{
							required: true,
							message: "請輸入確認密碼",
							trigger: 'blur',
						}
					],

				},
			}
		},
		methods: {
			hide(){
				this.$emit('hide')
			},
			//提交
			submitpass() {
				if (this.pass_arr.pass1 != this.pass_arr.pass2) {
					this.$message({
						message: '兩次密碼輸入不一致',
						type: 'error'
					});
					return
				}
				this.$refs.pass_form.validate(res => {
					if (res) {
						
						this.submitApi()
					}
				})
				
			},
			submitApi(){
				this.axios.post('/admin/user/editPass', this.pass_arr, {
					token: true
				}).then(res => {
					let all = res.data
					if (all.code == 1) {
						this.$message({
							message:   '修改成功',
							type: 'success'
						});
						this.hide()
					}
					
				}).catch(err => {
					
				})
			}
		}
	}
</script>

<style>
	.phone_w{
		width: 90%;;
	}
	.pc_w{
		width: 34%;;
	}
</style>
